// ProlongationButton.jsx
import React, { useState } from 'react';
import { FileText } from 'lucide-react';
import ProlongationModal from './ProlongationModal';
import './prolongationButton.css';

const ProlongationButton = ({ project, contractor, data }) => {
    const [open, setOpen] = useState(false);

    return (
        <>
            <button className="plb-trigger-btn buttonCSS " onClick={() => setOpen(true)}>
                <div className="plb-row">
                    <FileText size={20} className="plb-icon" />
                    {/* <div className="plb-stats-row">
                        <div className="plb-stat-chip total">
                            <span className="plb-chip-count">{project?.prolongation_count || 0}</span>
                            <span className="plb-chip-label">Total</span>
                        </div>
                        <div className="plb-stat-chip prolongation">
                            <span className="plb-chip-count">{project?.prolongation_prolongation_count || 0}</span>
                            <span className="plb-chip-label">Prolongation</span>
                        </div>
                        <div className="plb-stat-chip deviation">
                            <span className="plb-chip-count">{project?.prolongation_deviation_count || 0}</span>
                            <span className="plb-chip-label">Deviation</span>
                        </div>
                    </div> */}
                </div>
                <span className="plb-tooltip">View Summary</span>
            </button>

            <ProlongationModal
                open={open}
                onClose={() => setOpen(false)}
                project={project}
                contractor={contractor}
                data={data}
            />
        </>
    );
};

export default ProlongationButton;